<script setup lang="ts">
import {
  computed,
  defineEmits,
  defineProps,
  getCurrentInstance,
  withDefaults,
} from "vue"
import { resolveActionButtonType } from "./resolve-action-button.js"

const props = withDefaults(
  defineProps<{
    type: string
    icon?: string | null
    text?: string
    color?: string
    icon_only?: boolean
    icon_only_xs?: boolean
  }>(),
  {
    icon_only_xs: true,
  },
)

const emit = defineEmits<{ (e: "click", value: string): void }>()

const instance = getCurrentInstance()

function onClick(e: MouseEvent) {
  const target = e.target as HTMLButtonElement
  emit("click", target?.value ?? "")
}
const $t = (key: string) =>
  (instance?.proxy as { $t?: (k: string) => string } | undefined)?.$t?.(key) ??
  key

const resolved = computed(() => resolveActionButtonType(props.type, $t))

const computedBtnText = computed(() => {
  const fromType = resolved.value.text
  return props.text ? props.text : fromType
})

const btnIcon = computed(() => {
  if (props.icon) return props.icon
  if (props.icon === null) return null
  return resolved.value.icon
})

const btnColor = computed(() =>
  props.color ? props.color : resolved.value.color,
)

const computedIconOnly = computed(() => {
  if (props.icon_only) return true
  const xsOnly =
    (instance?.proxy as { $vuetify?: { breakpoint?: { xsOnly?: boolean } } })
      ?.$vuetify?.breakpoint?.xsOnly ?? false
  return xsOnly && props.icon_only_xs
})
</script>

<template>
  <v-btn
    v-bind="$attrs"
    @click="onClick"
    :color="btnColor"
    class="button_text--text cstm-v-btn darken-2"
    :title="computedBtnText"
  >
    <v-icon v-if="btnIcon" small>{{ btnIcon }}</v-icon>
    <span
      v-if="!computedIconOnly"
      :class="'d-sm-inline cstm-v-btn-text' + (btnIcon ? '' : ' pa-0')"
      >{{ computedBtnText }}</span
    >
  </v-btn>
</template>

<script lang="ts">
export default {
  inheritAttrs: true,
}
</script>
